module.exports = __webpack_public_path__ + "img/copy-img.5fcc20c9.svg";